import { render, staticRenderFns } from "./BaseIconButtonClose.vue?vue&type=template&id=2b593be7&scoped=true&"
import script from "./BaseIconButtonClose.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonClose.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconButtonClose.vue?vue&type=style&index=0&id=2b593be7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b593be7",
  null
  
)

export default component.exports